module.exports = __webpack_public_path__ + "img/elin_ereuna_ikanopoiisis310X588.558efe82.jpg";